import SideMenu from '@/containers/side-menu/SideMenu.vue';
import ParkingMeter from '@/pages/reports/parking-meter/ParkingMeter.vue';

export default {
  path: '/reports/parking-meter',
  name: 'ParkingMeter',
  components: {
    mainContent: ParkingMeter,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'report-parking-meter',
    },
    breadcrumb: {
      title: 'Relatório parquímetro',
      paths: [{ title: 'Relatórios' }, { title: 'Parquímetro' }],
    },
  },
};
